class Message {
  static show(type, text, duration = 2000) {
    const container = document.createElement('div');
    container.className = `liquid-message liquid-message-${type}`;

    const iconSpan = document.createElement('span');
    iconSpan.className = 'liquid-message-icon';
    container.appendChild(iconSpan);

    const textSpan = document.createElement('span');
    textSpan.className = 'liquid-message-text';
    textSpan.innerText = text;
    container.appendChild(textSpan);

    document.body.appendChild(container);
    window.getComputedStyle(container).opacity;
    container.classList.add('show');
    setTimeout(() => {
      container.classList.remove('show');
      container.classList.add('hide');
      container.addEventListener('transitionend', () => {
        container.remove();
      });
    }, duration);
  }

  static getIconSVG(type) {
    return '';
  }

  static success(text, duration) {
    this.show('success', text, duration);
  }
  static error(text, duration) {
    this.show('error', text, duration);
  }
  static warning(text, duration) {
    this.show('warning', text, duration);
  }
  static info(text, duration) {
    this.show('info', text, duration);
  }
}
